import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import { IBuildings } from '../Interfaces/IBuildings';
import { fromEvent, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class BuildingsService extends RestCallService {
	public dataToSend: IBuildings = {
		pkbuilding: 0,
		building: '',
		fksite: 0,
		address: '',
		city: '',
		state: '',
		postal_code: '',
		sitename: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 1,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 1,
		fkrecordstatus: 1,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
		available: true,
		fksiteloggeduser: 0,
		fkproject: 0,
		fkarea: 0,
	};

	constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
	}

	public GetList() {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		return this.post<IBuildings[]>(
      '/api/Buildings/GetBuildings',
      this.dataToSend
		);
	}

	public GetAvailableBuildings(pksite?: number) {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.fksite = pksite == null ? parseInt(localStorage.getItem('pksite')) : pksite;
		return this.post<IBuildings[]>(
      '/api/Buildings/GetAvailableBuildings',
      this.dataToSend
		);
	}

	public GetBuildingsBySite() {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.fksiteloggeduser = parseInt(
			localStorage.getItem('pksite'),
		);
		return this.post<IBuildings[]>(
			'/api/Buildings/GetBuildingsBySite',
			this.dataToSend,
		);
	}

	public GetBuildingsByPkProject(data: any){
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.fkproject = data;
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		return this.post<IBuildings[]>('/api/Buildings/GetBuildingsByPkProject',this.dataToSend,);
	}

	public GetBuildingsByPkArea(data: any){
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.fkarea = data;
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		return this.post<IBuildings[]>('/api/Buildings/GetBuildingsByPkArea',this.dataToSend,);
	}

	public CreateBuilding(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
    		this.cognitoService.LogOut();
		this.dataToSend.building = data.txtbuilding.trim();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.address = data.txtaddress.trim();
		this.dataToSend.city = data.txtcity.trim();
		this.dataToSend.state = data.txtstate.trim();
		this.dataToSend.postal_code = data.txtpostalcode.trim();
		this.dataToSend.fksiteloggeduser = parseInt(
			localStorage.getItem('pksite'),
		);
		return this.post('/api/Buildings/CreateBuilding', this.dataToSend);
	}

	public UpdateBuilding(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.pkbuilding = data.pkbuilding;
		this.dataToSend.building = data.txtbuilding.trim();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.address = data.txtaddress.trim();
		this.dataToSend.city = data.txtcity.trim();
		this.dataToSend.state = data.txtstate.trim();
		this.dataToSend.postal_code = data.txtpostalcode.trim();
		this.dataToSend.fksiteloggeduser = parseInt(
			localStorage.getItem('pksite'),
		);
		return this.put('/api/Buildings/UpdateBuilding', this.dataToSend);
	}

	public ChangeBuldingStatus(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.pkbuilding = data.pkbuilding;
		this.dataToSend.available = data.available;
		this.dataToSend.fksiteloggeduser = parseInt(
			localStorage.getItem('pksite'),
		);
		return this.put('/api/Buildings/ChangeBuildingStatus', this.dataToSend);
	}

	public GetBuildingsAvailableBySite() {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		return this.post<IBuildings[]>(
			'/api/Buildings/GetAvailableBuildingsBySite',
			this.dataToSend,
		);
	}
}
